import { render } from "./displaymodulegfair.vue?vue&type=template&id=657b6ae6"
import script from "./displaymodulegfair.vue?vue&type=script&lang=js"
export * from "./displaymodulegfair.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__